<template>
  <div>
    <top></top>
    <navMenu></navMenu>
    <div class="inner">
      <!-- <Header></Header> -->
      <!-- <nav-img></nav-img> -->
      <navbar></navbar>

      <div class="main clear">
        <div class="banner">
          <aside-left class="aside_left"></aside-left>
          <div class="right-top backwihte">
            <div class="logdetailstitle">
              <div class="logtitle" v-html="matterlist.journal_title">
                最懂“文娱”的马云走了，阿里的大文娱谁来拯救？
              </div>
              <div class="logmsglist">
                <span>{{ matterlist.create_time }} </span>
                <!-- <span>{{ matterlistc }}评论</span> -->
                <!-- <span>{{matterlistb}}点赞</span>
                        <span>{{}}收藏</span> -->
                <!-- <span>123转发</span> -->
                <!-- <span>123评论</span> -->
              </div>
              <div
                class="havepushfunctionb havepushfunctionc clear"
                v-show="issshow"
              >
                <div class="bianji" @click.stop="redactlog(matterlist)">
                  <i class="iconfont iconbianji"></i>
                </div>
                <div class="shanchu">
                  <i
                    class="iconfont iconshanchu"
                    @click.stop="deluppop(matterlist)"
                  ></i>
                </div>
              </div>
              <div class="havepushmatter" v-html="matterlist.journal_content">
                内容
              </div>
              <div class="discussmatterdiv clear">
                <div class="pingluntitle">
                  评论
                  <!-- ({{ matterlistc}}) -->
                </div>
                <div class="zhuanfa">
                  <svg
                    class="icon iconcssd"
                    aria-hidden="true"
                    @click="zhuanfa"
                  >
                    <use xlink:href="#iconzhuanfalan"></use>
                  </svg>
                  <span>0人转发</span>
                </div>
                <div class="shoucangico" @click="logcollect(matterlist)">
                  <svg
                    class="icon iconcssd"
                    aria-hidden="true"
                    v-if="matterlist.cstatus == 1"
                  >
                    <use xlink:href="#iconshoucanghuang"></use>
                  </svg>
                  <div class="falsecollect" v-else>
                    <i class="iconfont iconcollection-b"></i>
                  </div>
                  <span>{{ matterlist.colsum }}</span>
                </div>
                <div class="clickzan" @click="journalLike(matterlist)">
                  <svg
                    class="icon iconcssd"
                    aria-hidden="true"
                    v-if="matterlist.pstatus == 1"
                  >
                    <use xlink:href="#icondianzanhong"></use>
                  </svg>
                  <div class="falsecollect iconlike" v-else>
                    <i class="iconfont iconxin"></i>
                  </div>
                  <span>{{ matterlist.psum }}</span>
                </div>
              </div>
              <textarea class="dynamicinp" v-model="matter"></textarea>
              <div class="publishbtn">
                <el-button
                  type="primary"
                  round
                  @click="dynamicbtn(matterlist)"
                  size="mini"
                  >发表</el-button
                >
              </div>
              <div class="dynamic_list" v-show="commentdatatype == true">
                <ul
                  class="active2"
                  v-for="conlist in this.commentlist"
                  :key="conlist.comment_id"
                >
                  <li>
                    <img :src="conlist.avatar" />
                    <div class="pinglunbox">
                      <p>
                        <span>{{ conlist.user_nicename }} : </span
                        >{{ conlist.comment_content }}
                      </p>
                      <p>
                        {{ conlist.create_time
                        }}<span class="hovtext" @click="dynamicbtn2(conlist)"
                          >回复</span
                        >
                        <span class="hovtext" @click="delcot(conlist)"
                          >删除</span
                        >
                      </p>
                    </div>
                    <div
                      class="pinglun"
                      style="display: none"
                      :class="{ isshow: conlist.comment_id == xiaoxi2 }"
                    >
                      <input
                        class="huifuinput"
                        :placeholder="saymsg"
                        @keyup.enter="search2"
                        @blur.prevent="changeCount1()"
                        @input="search2($event)"
                      />
                      <!-- 发表按钮 -->
                      <el-button
                        class="huifubtn"
                        type="primary"
                        round
                        v-model="text2"
                        size="mini"
                        @click="huifu(conlist.dynamic_id, conlist.comment_id)"
                        >回复</el-button
                      >
                    </div>
                    <ol>
                      <li v-for="(conlist2, inx) in conlist.child" :key="inx">
                        <img :src="conlist2.avatar" />
                        <div>
                          <p>
                            <span>{{ conlist2.user_nicename }}</span> 回复
                            <span>{{ conlist2.user_nicename }}</span> :
                            {{ conlist2.comment_content }}
                          </p>
                          <p>
                            {{ conlist2.create_time
                            }}<span class="hovtext1" @click="delcot(conlist2)"
                              >删除</span
                            >
                          </p>
                        </div>
                      </li>
                    </ol>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <advertising class="aside_left_two"></advertising>
        </div>
        <!-- 点击发分享范围态生成的对话框 -->
        <el-dialog
          title="转发至"
          :visible.sync="shareDialogVisible"
          width="30%"
        >
          <span>
            <el-checkbox-group
              v-model="checkedCities"
              @change="handleCheckedCitiesChange"
            >
              <el-checkbox
                v-for="item in cities"
                :label="item"
                :key="item.id"
                >{{ item.space_name }}</el-checkbox
              >
            </el-checkbox-group>
          </span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="xianshi(1)">取 消</el-button>
            <el-button type="primary" @click="xianshi(2)">确 定</el-button>
          </span>
        </el-dialog>
      </div>

      <div class="dingbu">
        <scroll-top></scroll-top>
      </div>
    </div>
  </div>
</template>
<script>
import top from "@/components/common/top.vue";
import navMenu from "@/components/common/navMenu.vue";
// 引入主导航栏区域
import Header from "../../../components/space/Header";
// 引入主体背景区域
import NavImg from "../../../components/space/NavImg";
// 引入导航栏区域
import Navbar from "../../../components/space/Navbar";
// 引入侧边栏区域
import AsideLeft from "../../../components/space/Aside";
import Advertising from "../../../components/space/advertising";
import URL from "../../../api/index";
import scrollTop from "../../../components/space/scrollTop";
import axios from "axios";
export default {
  components: {
    top,
    navMenu,
    Header,
    NavImg,
    Navbar,
    AsideLeft,
    Advertising,
    scrollTop,
  },
  data() {
    return {
      activeName: "first",
      getspaceinfo: "",
      spaceid: "",
      attention: true,
      attentionb: false,
      matter: "",
      pinglunitem: "",
      spaid: "",
      logtitle: "",
      journal_id: "",
      journal_content: "",
      matterlist: "",
      matterlistb: "",
      matterlistc: "",
      matterlistd: "",
      journal_title: "",
      journalid: "",
      UserInfo: "",
      checkedCities: [],
      cities: "",
      shareDialogVisible: false,
      commentlist: "",
      commentdatatype: true,
      text2: "",
      saymsg: "",
      xiaoxi: "4vKJdSi7",
      xiaoxi2: "4vNqqJkv",
      issshow: true,
      iteminfo: "",
      draft: "",
    };
  },
  created() {
    // 获取用户信息、
    this.UserInfo = JSON.parse(window.localStorage.getItem("info"));
    this.journalid = this.$route.query.journalid;
    this.loadmatter();
    this.getCommentList();
  },
  mounted() {
    this.UserInfo = JSON.parse(window.localStorage.getItem("info"));
    this.getSpaceinfo = JSON.parse(window.localStorage.getItem("getSpaceinfo"));
    this.iteminfo = JSON.parse(window.localStorage.getItem("iteminfo"));
    if (this.iteminfo) {
      this.issshow = false;
    } else {
      this.issshow = true;
    }
    var that = this;
    var userspace_data = {
      token: that.UserInfo.token,
      user_id: that.UserInfo.user_id,
    }; // 关注的空间列表
    this.$post(URL.userspace, userspace_data).then((res) => {
      var cityOptions = res.result;
      that.cities = cityOptions;
    });
  },
  methods: {
    handleCheckedCitiesChange(e) {
      this.checkedCities = e;
    },
    changeCount1() {},
    loadmatter() {
      //获取日志详情
      var dynamicdata = {
        token: this.UserInfo.token,
        journalid: this.journalid,
      };
      this.$post(URL.dynamicdetail, dynamicdata).then((item) => {
        if (item.state == 0) {
          this.matterlist = item.result.journal;
          localStorage.setItem(
            "rizhi_zhuan_data",
            JSON.stringify(this.matterlist)
          );
        } else {
          this.$message.error(item.msg);
        }
      });
    },
    //评论
    dynamicbtn(journalmatter) {
      var commentid = 0;
      var commentdata = {
        token: this.UserInfo.token,
        dynamic: journalmatter.journal_id,
        comtype: "journal",
        comment: this.matter,
      };
      if (!this.matter) {
        this.$message.error("内容不能为空");
      } else {
        this.$post(URL.addComment, commentdata).then((item) => {
          if (item.data.state == 0) {
            this.matter = "";
            this.getCommentList();
          } else {
          }
          //this.newsrecent();//评论后重新请求最新动态
        });
      }
    },
    //获取评论
    getCommentList() {
      var commlistdata = {
        comtype: "journal",
        dynamic: this.journalid,
        token: this.UserInfo.token,
      };
      this.$post(URL.getCommentList, commlistdata).then((item) => {
        this.commentlist = item.result;
        if (this.commentlist == "") {
          this.commentdatatype = false;
        } else {
          this.commentdatatype = true;
        }
        // commentdata
      });
    },
    //编辑日志
    redactlog(jourinfo) {
      localStorage.setItem("jourinfo", JSON.stringify(jourinfo));
      this.$router.push({
        name: "editlog",
        query: {
          edittype: 2,
        },
      });
    },

    //删除提示
    deluppop(journalmatter) {
      this.draft = journalmatter.draft;
      console.log(journalmatter);
      this.$confirm("你确定删除吗？", "提示消息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.deljournal(journalmatter);
        })
        .catch(() => {});
    },
    //删除日志
    deljournal(journalmatter) {
      var deljournaldata = {
        token: this.UserInfo.token,
        journal_id: journalmatter.journal_id,
      };
      this.$post(URL.deljournal, deljournaldata).then((res) => {
        this.getRjwDel(
          JSON.parse(localStorage.getItem("loginInfo")),
          journalmatter.journal_id
        );
        if (res.state == 0) {
          this.$message.success(res.msg);
          this.$router.push("/space/journal");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //数据上报
    getRjwDel(hh, row) {
      axios.get("https://access.rujiaowang.net/GetLogServer").then((res) => {
        this.client_ip = res.data.result.client_ip;
        var differenctime =
          res.data.result.net_ts - Date.parse(new Date()) / 1000;
        // 进入空间
        var saydata = {
          product_name: "教师工作台",
          log_version: "v2.0.1",
          action: "studyspace_delete",
          user_id: String(hh.user_id),
          user_role: String(hh.user_type),
          user_name: String(hh.user_nicename),
          ts: String(Number(Date.parse(new Date())) / 1000 + differenctime),
          trace_id: JSON.parse(localStorage.getItem("data_traceid")),
          dev_id: "",
          dev_name: "",
          client_ip: this.client_ip,
          os: "",
          cpu_name: "",
          cpu_use: "",
          app_version: "v2.0.0",
          mem_size: "",
          mem_use: "",
          net: "",
          electric: "",
          extend: "",
          remark: `${hh.user_nicename}` + "使用了网络学习空间的删除功能",
          data: {
            function: "日志",
            school_name: hh.teacher_info.school_name
              ? `${hh.teacher_info.school_name}`
              : "",
            school_id: hh.teacher_info.school_id
              ? `${hh.teacher_info.school_id}`
              : "",
            trace_id: JSON.parse(localStorage.getItem("space_traceid")),
            delete_id: row,
            source: this.draft == "1" ? "已发布" : "草稿箱",
          },
        };
        axios.post("http://47.114.114.56:9002/RecordRjw", saydata);
      });
    },
    //收藏
    logcollect(journalmatter) {
      var collectdata = {
        coltype: "journal",
        content: journalmatter.journal_id,
        token: this.UserInfo.token,
      };
      this.$post(URL.collect, collectdata).then((item) => {
        if (item.state == 0) {
          // this.$emit('deljou','remove');
          this.loadmatter();
        } else {
          this.$message.error(item.msg);
        }
      });
    },
    //点赞
    journalLike(journalmatter) {
      var journalLikedata = {
        token: this.UserInfo.token,
        journalid: journalmatter.journal_id,
      };
      this.$post(URL.journalLike, journalLikedata).then((item) => {
        if (item.state == 0) {
          this.loadmatter();
        } else {
          this.$message.error(item.msg);
        }
      });
    },
    zhuanfa() {
      this.shareDialogVisible = true;
    },
    xianshi(e) {
      var that = this;
      if (e == 1) {
        that.shareDialogVisible = false;
      } else if (e == 2) {
        that.checkedCities.forEach(function (e) {
          that.addzhuanfa(e.space_id);
        });
      }
    },
    //发表动态
    addzhuanfa(e) {
      var that = this;
      var zhuanfa_data = JSON.parse(
        window.localStorage.getItem("rizhi_zhuan_data")
      );
      var data = {
        token: that.UserInfo.token,
        journalid: zhuanfa_data.journal_id,
        spaceid: e,
      };
      this.$post(URL.transpondJournal, data).then((res) => {
        this.$message({
          message: res.msg,
        });

        that.shareDialogVisible = false;
      });
    },
    // 删除评论
    delcot(e) {
      var that = this;
      var addComment_data3 = {
        token: that.UserInfo.token,
        commentid: e.comment_id,
      };
      this.$post(URL.delComment, addComment_data3).then((res) => {
        that.getCommentList(e.dynamic_id);
      });
    },
    dynamicbtn2(e) {
      if (this.xiaoxi2 == e.comment_id) {
        this.xiaoxi2 = "";
      } else {
        this.xiaoxi2 = e.comment_id;
        this.saymsg = "回复 " + e.user_nicename + ":";
      }
    },
    // 回复
    huifu(a, e) {
      var that = this;
      var addComment_data2 = {
        token: that.UserInfo.token,
        comment: that.text2,
        dynamic: a,
        comment_id: e,
        comtype: "dynamic",
      };
      // 留言中评论
      this.$post(URL.addComment, addComment_data2).then((res) => {
        that.delcot(a);
        that.xiaoxi2 = "";
      });
    },
    // 回复
    search2(event) {
      this.text2 = event.currentTarget.value;
    },
  },
};
</script>
<style lang="less">
.box {
  padding-top: 20px;
}
.huifuinput {
  outline: none;
  border: 0;
  width: 88%;
  height: 30px;
  text-indent: 1rem;
  line-height: 50px;
  background-color: #ffffff;
  border-radius: 4px;
  border: solid 1px #d3d7e0;
  font-size: 15px;
}
.isshow {
  display: block !important;
}
.huifubtn {
  margin-top: 0px;
  display: block;
  margin-left: 10px;
}
.active2 {
  display: block !important;
}
.main {
  background-color: #f5f6f8;
}
.banner {
  padding: 25px 0;
  margin: 0 auto;
  width: 1200px;
  overflow: hidden;
}
.main .right-top {
  width: 870px;
  float: right;
  margin-bottom: 40px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -ms-box-sizing: border-box;
  box-sizing: border-box;
}
.main .left .left-top {
  width: 100%;
  height: 300px;
  margin-bottom: 20px;
  margin-top: 10px;
  background: #fff;
}
.backwihte {
  height: auto !important;
  padding: 35px;
  background: #fff;
}
.logdetailstitle {
  position: relative;
}
.logtitle {
  color: #2b2b2b;
  font-size: 28px;
}
.logmsglist {
  margin-top: 20px;
  padding-bottom: 26px;
  border-bottom: 1px solid #dfdfdf;
}
.logmsglist span {
  margin-right: 26px;
  font-size: 14px;
}
.havepushfunctionb {
  display: inline-block;
  position: absolute;
  top: 0px;
  right: 0;
}
.havepushfunctionc {
  top: 50px !important;
}
.havepushfunctionb div {
  width: 42px;
  height: 42px;
  float: left;
  border-radius: 50%;
  background: #ebebeb;
  cursor: pointer;
  text-align: center;
}
.havepushfunctionb div i {
  color: #a3a3a3;
  font-size: 28px;
  line-height: 42px;
}
.havepushfunctionb div:nth-child(1) {
  margin-right: 20px;
}
.havepushmatter {
  padding: 14px 0 45px 0;
}
.havepushmatter a {
  color: #409eff;
}
.havepushmatter p {
  color: #2b2b2b;
  font-size: 16px;
  text-indent: 2em;
  line-height: 30px;
}
.havepushmatter img {
  display: block;
  margin: 5px auto;
}
.discussmatterdiv {
  height: 65px;
}
.pingluntitle {
  color: #2b2b2b;
  font-size: 24px;
  float: left;
}
.clickzan,
.shoucangico {
  float: right;
}
.shoucangico {
  margin: 0 25px;
}
.clickzan span {
  color: #ff5656;
}
.clickzan span,
.shoucangico span,
.zhuanfa span {
  margin-left: 8px;
  float: right;
  line-height: 44px;
}
.iconcssd {
  width: 40px !important;
  height: 40px !important;
}
.shoucangico span {
  color: #fe9a38;
}
.aside_left {
  float: left;
}
.newMood {
  padding: 25px 0;
  margin: 0 auto;
  width: 1200px;
  overflow: hidden;
}

.discussmatterdiv .publishbtn div {
  background: #2c84ff;
}
.dynamicinp {
  width: 98%;
  height: 30px;
  text-indent: 1em;
  color: #898989;
  font-size: 16px;
  line-height: 30px;
  outline: none;
  border: 1px solid #efefef;
  background: #fff;
  resize: none;
  margin: 10px 0 0 10px;
}
.publishbtn {
  width: 98%;
  height: 50px;
  margin-left: 10px;
  background: #fff;
  // border-bottom: 1px solid #efefef;
}
.publishbtn button {
  float: right;
  margin-top: 10px;
}
.zhuanfa {
  float: right;
}
.zhuanfa,
.shoucangico,
.clickzan {
  cursor: pointer;
}
.falsecollect {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #ebebeb;
  text-align: center;
  cursor: pointer;
  float: left;
}
.falsecollect i {
  line-height: 40px;
  font-size: 20px;
  color: #b6b6b6;
}
.iconlike i {
  font-size: 26px;
  line-height: 44px;
}
.bianji:hover i {
  color: #fff !important;
}
.shanchu:hover {
  background: #ff5656 !important;
}
.shanchu:hover i {
  color: #fff !important;
}
.dynamic_list {
  width: 100%;
  background-color: #ffffff;
  box-shadow: 0px 0px 8px 0px rgba(15, 26, 47, 0.06);
  border-radius: 4px;
  box-sizing: border-box;
  padding: 25px 25px 18px;
  overflow: hidden;
  margin-bottom: 12px;
  .header {
    width: 100%;
    overflow: hidden;

    .img_header {
      float: left;
      .img {
        padding: 8px 14px 0 3px;
        float: left;
        img {
          width: 42px;
          height: 42px;
          border-radius: 50%;
          overflow: hidden;
          border: 1px solid #ccc;
        }
      }
      .infomation {
        float: left;
        color: #898989;
        p {
          padding: 7px 0 4px 0;
          font-size: 14px;
          color: #000;
          .el-tag {
            margin-left: 10px;
          }
        }
        span {
          font-size: 12px;
          padding-right: 5px;
        }
      }
    }
    .el-dropdown {
      float: right;
      font-size: 20px;
      cursor: pointer;
    }
  }
  .txt {
    float: right;
    width: 768px;
    // margin-top: 20px;
    .isshow {
      display: block !important;
    }
    p {
      color: #2b2b2b;
      font-size: 16px;
      line-height: 25px;
    }
    .anniu {
      height: 60px;
      line-height: 60px;
      padding-top: 20px;
      box-sizing: border-box;
      padding-left: 460px;
      user-select: none;
      .xihuan,
      .xiaoxi,
      .shoucang,
      .zhuanfa {
        line-height: 39px;
        float: left;
        margin-right: 23px;
        .iconzhuanfa,
        .iconcollection-b {
          line-height: 35px !important;
          font-size: 19px !important;
        }
        div {
          float: left;
          width: 36px;
          height: 36px;
          border-radius: 50%;
          background: #ebebeb;
          text-align: center;
          cursor: pointer;
          margin-right: 10px;
          i {
            line-height: 40px;
            color: #b6b6b6;
            font-size: 23px;
          }
        }
        span {
          color: #2b2b2b;
          font-size: 16px;
        }
      }
      .xihuan:hover {
        div {
          background-color: #ff5656 !important;
          i {
            color: #fff !important;
          }
        }
      }
      .xiaoxi:hover {
        div {
          background: #66b1ff !important;
        }
        i {
          color: #fff !important;
        }
      }
      .shoucang:hover {
        div {
          background-color: #ffcd56 !important;
          .iconcollection-b {
            color: #fff !important;
          }
        }
      }
      .zhuanfa:hover {
        div {
          background: #4bc2ff !important;
        }
        i {
          color: #ffffff;
        }
      }
    }
    .pinglun {
      cursor: text;
      box-sizing: border-box;
      margin-top: 15px;
      display: block;
      width: 99%;

      input {
        outline: none;
        border: 0;
        width: 97%;
        height: 30px;
        text-indent: 1rem;
        line-height: 50px;
        background-color: #ffffff;
        border-radius: 4px;
        border: solid 1px #d3d7e0;
        font-size: 15px;
      }
      .huifuinput {
        height: 23px;
        font-size: 10px;
        width: 87%;
      }
      .huifubtn {
        margin-top: 0px;
        display: block;
      }
    }
    .isshow {
      display: block !important;
    }
    .el-button {
      float: right;
      margin-top: 10px;
      margin-right: 20px;
      display: none;
    }

    .active div {
      background-color: #ff5656 !important;
      .iconxin {
        color: #fff !important;
      }
    }
    .active span {
      color: #295c9d !important;
    }
    .active1 div {
      background-color: #ffcd56 !important;
      .iconcollection-b {
        color: #fff !important;
      }
    }
    .active2 .pinglunbox:hover {
      .hovtext {
        cursor: pointer;
        color: #295c9d;
        margin-left: 4px;
        visibility: inherit !important;
      }
    }
    .active2 ol li:hover {
      .hovtext1 {
        cursor: pointer;
        color: #295c9d;
        margin-left: 4px;
        visibility: inherit !important;
      }
    }
    .active2 .hovtext {
      visibility: hidden !important;
    }
    .active2 .hovtext1 {
      visibility: hidden !important;
    }
  }
  ul {
    display: none;
    float: left;
    padding: 8px 10px 0;
    width: 98%;
    li {
      overflow: hidden;
      padding-top: 10px;
      width: 100%;
      img {
        display: inline-block;
        width: 33px;
        height: 33px;
        vertical-align: middle;
        margin-right: 1em;
        border-radius: 50%;
      }
      div {
        display: inline-block;
        vertical-align: middle;
        p {
          span {
            // cursor: pointer;
            color: #295c9d;
          }
          &:first-child {
            font-size: 12px;
            line-height: 20px;
          }
          &:last-child {
            font-size: 12px;
            line-height: 20px;
            // color: #409EFF;
          }
        }
      }
    }
  }
  ol {
    margin-left: 48px;
  }
  .hovtext {
    cursor: pointer;
  }
}
</style>